// Bir necha modulda takrorlanadigan zod bo'laklari.
//
// NEGA BIR JOYDA: `Money` sxemasi har feature'da qayta yozilsa, birontasida
// `currency` ixtiyoriy qilib qo'yiladi va u yerda summa jimgina birliksiz
// qoladi. Chegara validatsiyasining butun ma'nosi shunda — bir marta to'g'ri
// yozib, hamma joyda ishlatish.

import { z } from 'zod'
import type { Money } from '@/shared/lib/money'

/** Backend `platform.api.Money` — MINOR birlikdagi butun son + ISO 4217 kodi */
export const moneySchema = z.object({
  amount: z.number(),
  currency: z.string(),
})

/**
 * `Money` bo'lishi ham, `"NOT_SET"` satri bo'lishi ham mumkin bo'lgan maydon.
 *
 * `AgentMoneyController.balance` qarz limitini aynan shunday qaytaradi va bu
 * ataylab: "limit qo'yilmagan" va "limit nol" boshqa-boshqa holatlar
 * (birinchisi sozlanmagan, ikkinchisi ataylab yopilgan). `null` ikkalasini
 * ham anglatib, farqni yo'qotardi.
 */
export const debtLimitSchema = z.union([moneySchema, z.literal('NOT_SET')])

/** ISO-8601 UTC. Backend `Instant` ni shu ko'rinishda beradi ("...Z") */
export const instantSchema = z.string()

export const uuidSchema = z.string()

/** Zod natijasini ilova ichidagi `Money` tipiga keltiradi */
export function toMoney(raw: z.infer<typeof moneySchema>): Money {
  return { amount: raw.amount, currency: raw.currency.toUpperCase() }
}

/**
 * Paket HOZIR sotiladimi — backend aytadi, aytmasa eski qoida ishlaydi.
 *
 * ⚠️ NEGA SHARED'DA: paketlar ro'yxati IKKI joyda o'qiladi —
 * `features/catalog/catalogApi.ts` (Paketlar sahifasi) va
 * `shared/api/reference.ts` (sotish/yaratish oynalaridagi tanlov). Qoida
 * ikki nusxada yozilsa, biri yangilanib ikkinchisi eskirardi va aynan
 * SOTUV ro'yxati eski nusxada qolib ketardi — ya'ni panel sotib
 * bo'lmaydigan tarifni taklif qilishda davom etardi.
 *
 * ⚠️ Backend qoidasi: `state == ACTIVE && !misconfigured`
 * ({@code Plan.isSellable()}). Siyosati UNUTILGAN tarif ro'yxatda
 * KO'RINADI (operator uni tuzatishi kerak), lekin SOTILMAYDI.
 *
 * ⚠️ Maydon kelmasa (panel yangi, backend eski — §25) `false` DEB
 * HISOBLAMAYMIZ: unda paket sotish oynasi butunlay bo'shab qolardi.
 * Eski backendning qoidasi aynan `state == ACTIVE` edi.
 */
export function planSellable(raw: { sellable?: boolean | null; state: string }): boolean {
  return raw.sellable ?? raw.state === 'ACTIVE'
}

/** `Money | "NOT_SET"` → `Money | null` ("qo'yilmagan" = `null`) */
export function toOptionalMoney(raw: z.infer<typeof debtLimitSchema>): Money | null {
  return raw === 'NOT_SET' ? null : toMoney(raw)
}
